import { ReactComponent as IconGreenTick } from "@/assets/svgs/green-tick.svg";
import { ReactComponent as IconQuestionMark } from "@/assets/svgs/icon-question-mark.svg";
import { uniqueId } from "lodash";
import tradeTrustType from "@/constants/trade-trust-type/index";
import PropTypes from 'prop-types';

export const getVerificationStatusArray = (verificationFragments) => {
    const verificationStatusArr = [];

    verificationFragments?.map(({ type, status }) => {
        if (type === "DOCUMENT_INTEGRITY" && status === "VALID") {
            verificationStatusArr.push("Document has not been tampered with");
        }
        if (type === "DOCUMENT_STATUS" && status === "VALID") {
            verificationStatusArr.push("Document has been issued");
        }
        if (type === "ISSUER_IDENTITY" && status === "VALID") {
            verificationStatusArr.push("Issuer has been identified");
        }
        return verificationStatusArr;
    });

    return verificationStatusArr;
};

const VerificationStatus = ({ verificationFragments, ttStatus }) => {
	const verificationStatusArr = getVerificationStatusArray(verificationFragments);

	return (
		<div className="verification_status__div" data-testid="verification_status__div">
			{verificationStatusArr.map((statusText) => {
				const id = uniqueId()
				return (
					<div className="verification_status__div__flex" key={id}>
						{ttStatus === tradeTrustType.unknown ? <IconQuestionMark />:<IconGreenTick />}
						<div className="status_tick__span__text__grey">
							{statusText}
						</div>
					</div>
				);
			})}
		</div>
	);
};

VerificationStatus.propTypes = {
	verificationFragments: PropTypes.array,
	ttStatus: PropTypes.string
}

export default VerificationStatus;
